import React, { useEffect, useState } from "react"
import _ from "lodash"

import { FormSection, FormRow, SectionFormWell } from "styles/form-styles"
import { Dropdown_s } from "styles/input-styles"
import NumberInput from "components/inputs/number"
import { OrgSettings_s } from "./user-styles"
import organizationService from "data/organization"
import validationService from "data/validate"
import { local } from "data/lib/local-json"
import { field_attrs } from "components/table/lib/column-field"
import { Errors } from "components/asset-management/errors"
import { Toolbar } from "components/subnav"

const OrgSettings = (props) => {
  const [orgData, setOrgData] = useState<object|null>(null)
  const [_errors, setErrors] = useState<any>()
  const orgId = _.get(local("auth.profile"), 'organizationId');
  const firstInput = document.getElementById('defaultPropertyTypeInput');

  const validationFilter = (errors):object => {
    return {
      ...errors,
      errordetail: _.pick(errors.errordetail, 'organization'),
      calcDetail: undefined
    }
  }

  useEffect(() => {
    const organizationSubscription = organizationService.stream().subscribe(data => {
      if (data.value) setOrgData(data.value);
    })

    const validationSubscription = validationService.stream().subscribe((e) => {
      setErrors(e)
    })

    validationService.addFilter(validationFilter)

    return function cleanup() {
      organizationSubscription.unsubscribe()
      validationSubscription.unsubscribe()
      validationService.removeFilter(validationFilter)
    }
  }, [])

  useEffect(() => {
    firstInput?.classList.add('p-focus', 'p-inputwrapper-focus')
    const input = firstInput?.getElementsByTagName('input')[0];
    input?.focus();
  }, [firstInput])

  useEffect(() => {
    organizationService.fetch(orgId)
  }, [orgId])

  useEffect(() => {
    validationService.validate('organization')
  }, [orgData])

  function update(key, val):void {
    let nextData = _.cloneDeep(orgData);
    nextData['organizationdetail'][key] = val
    organizationService.patch(nextData)
  }

  const attrs = (field) => field_attrs('organization')(field)(orgData, props)

  return (
    <div>
      <Toolbar>
        <Errors />
      </Toolbar>
      <OrgSettings_s>
        { orgData &&
        <FormSection className="settings-form">
          <FormRow>
            <div>
              <label htmlFor="defaultPropertyTypeInput">
                Default Property Type
              </label>
              <Dropdown_s
                className="automated"
                id="defaultPropertyTypeInput"
                value={orgData['organizationdetail']['defaultPropertyType']}
                onChange={e => update('defaultPropertyType', e.target.value)}
                options={['Commercial', 'Hospitality', 'Multifamily'].map(propType => { return { label: propType, value: propType }})}
              />
            </div>
            <div>
              <label htmlFor="defaultFolderTermInput">
                Default Folder Term (Years)
              </label>
              <NumberInput
                id="defaultFolderTermInput"
                className="automated"
                attrs={attrs}
                field={'organizationdetail.defaultFolderTerm'}
                value={orgData['organizationdetail']['defaultFolderTerm']}
                persist={(field, val) => update('defaultFolderTerm', val)}
                respectFocus
              />
            </div>
            <div>
              <label htmlFor="defaultPropertyTermInput">
                Default Property Term (Years)
              </label>
              <NumberInput
                id="defaultPropertyTermInput"
                className="automated"
                field={'organizationdetail.defaultPropertyTerm'}
                attrs={attrs}
                value={orgData['organizationdetail']['defaultPropertyTerm']}
                persist={(field, val) => update('defaultPropertyTerm', val)}
                respectFocus
              />
            </div>
          </FormRow>
          <SectionFormWell>
            <FormRow>
              <div>
                <label htmlFor="folderOffsetInput">
                  Default Folder Report Begin Date <br /> (Months Offset from Current Date)
                </label>
                <NumberInput
                  id="folderOffsetInput"
                  className="automated"
                  attrs={attrs}
                  field={'organizationdetail.folderOffset'}
                  value={orgData['organizationdetail']['folderOffset']}
                  persist={(field, val) => update('folderOffset', val)}
                  respectFocus
                />
              </div>
              <div>
                <label htmlFor="propertyOffsetInput">
                  Default Property Analysis Begin Date <br/> (Months Offset from Current Date)
                </label>
                <NumberInput
                  id="propertyOffsetInput"
                  className="automated"
                  attrs={attrs}
                  field={'organizationdetail.propertyOffset'}
                  value={orgData['organizationdetail']['propertyOffset']}
                  persist={(field, val) => update('propertyOffset', val)}
                  respectFocus
                />
              </div>
            </FormRow>
          </SectionFormWell>
          {/* <CarouselAutomation
            outsideTable={true}
            automationActive={automationActive}
            automationClass="automated"
            editableFilters={false}
            includeSearchBar={false}
            tabOut={() => { setAutomationActive(false) }}
          /> */}
        </FormSection> }
      </OrgSettings_s>
    </div>
  )
}

export default OrgSettings
